import { Factory } from '@infodata-group/inf-commons';
import { Holiday } from '../model/holiday';

export class HolidayFactory implements Factory<Holiday> {
  api: string;

  constructor(api: string) {
    this.api = api;
  }

  build(o: any): Holiday {
    return new Holiday(o.date);
  }

  getApi(): string {
    return 'holidays' + this.api;
  }
}
